import BillsService from "@/services/bills.service";

const state = {
  selectedRange: null,
  search: {
    q: "",
    filter: [],
    issue_date: null
  },
  categories: [],
  categoriesInprogress: false,
  bills: [],
};

const getters = {
  search: state => {
    return state.search;
  },
  bills: state => {
    return state.bills;
  },
  selectedRange: state => {
    return state.selectedRange;
  },
  categories: state => {
    return state.categories;
  }
};


const actions = {
  async doSearch({
    commit
  }, query) {
    let bills = await BillsService.search(query);
    commit("bills", bills);
    return bills;
  },
  async create({
    commit
  }, form) {
    let bill = await BillsService.create(form);
    commit('push', bill);
    return bill;
  },
  async update({
    commit
  }, {
    billid,
    form
  }) {
    let bill = await BillsService.update(billid, form);
    commit('update', {
      bill: bill,
      id: billid
    });
    return bill;
  },
  async remove({
    commit
  }, billid) {
    await BillsService.delete(billid);
    commit('remove', billid)
    return;
  },
  async loadCategories({
    commit,
    state
  }) {
    if (state.categoriesInprogress === false && state.categories.length === 0) {
      commit("categoriesInprogress");
      let categories = await BillsService.loadCategories();
      commit("categories", categories);
    }
    return true;
  },
  async addCategory({
    commit
  }, name) {
    let category = await BillsService.addCategory(name);
    commit('pushCategory', category);
    return category;
  },
  async updateCategory({
    commit
  }, {
    categoryid,
    name
  }) {
    let category = await BillsService.updateCategory(categoryid, name);
    commit('updateCategory', {
      categoryid: categoryid,
      name: name
    });
    return category;
  },
  async deleteCategory({
    commit
  }, categoryid) {
    await BillsService.deleteCategory(categoryid);
    commit('removeCategory', categoryid)
    return;
  },
  async unattachBill({
    commit
  }, {
    constructionid,
    billid
  }) {
    await BillsService.unattachConstraction(constructionid, billid);
    commit('remove', billid);
    return;
  }
};

const mutations = {
  search(state, {
    type,
    value
  }) {
    state.search[type] = value;
  },
  range(state, {
    selected,
    range
  }) {
    state.selectedRange = selected;
    state.search.issue_date = range;
  },
  bills(state, payload) {
    state.bills = payload;
  },
  push(state, payload) {
    state.bills.unshift(payload);
  },
  update(state, {
    bill,
    id
  }) {
    let billIndex = state.bills.findIndex((item) => (item.id === id));
    if (billIndex >= 0)
      state.bills[billIndex] = bill;
  },
  remove(state, id) {
    let billIndex = state.bills.findIndex((item) => (item.id === id));
    if (billIndex >= 0)
      state.bills.splice(billIndex, 1)
  },
  categories(state, payload) {
    state.categories = payload;
    state.categoriesInprogress = false;
  },
  categoriesInprogress(state){
    state.categoriesInprogress = true;
  },
  pushCategory(state, category) {
    state.categories.push(category);
  },
  updateCategory(state, {
    categoryid: categoryid,
    name: name
  }) {
    let category = state.categories.find((item) => (item.id === categoryid));
    category.name = name;
  },
  removeCategory(state, categoryid) {
    let categoryIndex = state.categories.findIndex((item) => (item.id === categoryid));
    if (categoryIndex >= 0)
      state.categories.splice(categoryIndex, 1)
  },
  reset(state) {
    state.bills = [];
  }
};


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};